import type { FeaturedToy } from './toy'

export function str(v: unknown): string | undefined {
  return typeof v === 'string' && v.length > 0 ? v : undefined
}

/**
 * Convert a free-form entry (e.g. from the user's toy-index.json) into the
 * shape the UI consumes. Returns null if required fields are missing.
 */
export function entryToToy(entry: Record<string, unknown>): FeaturedToy | null {
  const id = str(entry.id)
  const title = str(entry.title)
  if (!id || !title) return null
  return {
    id,
    title,
    version: str(entry.version),
    creatorName: str(entry.creatorName),
    creatorId: str(entry.creatorId),
    description: str(entry.description),
    manifestFilename: str(entry.manifestFilename),
    manifestUrl: str(entry.manifestUrl),
    thumbnailUrl: str(entry.thumbnailUrl),
  }
}
